"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerHealthbar = PlayerHealthbar;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const models_1 = require("@creature-chess/models");
const progressBar_1 = require("../progressBar");
const GREEN = [0x46, 0xc4, 0x5a];
const ORANGE = [0xe0, 0xa2, 0x3a];
const RED = [0xe2, 0x50, 0x4f];
const GREEN_THRESHOLD = 0.8;
const RED_THRESHOLD = 0.2;
const lerp = (a, b, t) => Math.round(a + (b - a) * t);
const toRgb = ([r, g, b]) => `rgb(${r}, ${g}, ${b})`;
const healthColor = (ratio) => {
    if (ratio >= GREEN_THRESHOLD) {
        return toRgb(GREEN);
    }
    if (ratio <= RED_THRESHOLD) {
        return toRgb(RED);
    }
    // orange sits at the midpoint. lerp red→orange→green across [0.2, 0.8]
    const mid = (GREEN_THRESHOLD + RED_THRESHOLD) / 2;
    const [from, to, t] = ratio > mid
        ? [ORANGE, GREEN, (ratio - mid) / (GREEN_THRESHOLD - mid)]
        : [RED, ORANGE, (ratio - RED_THRESHOLD) / (mid - RED_THRESHOLD)];
    return toRgb(from.map((c, i) => lerp(c, to[i], t)));
};
const useStyles = (0, react_jss_1.createUseStyles)({
    playerHealth: {
        position: "relative",
        display: "block",
        width: "100%",
        height: "16px",
    },
    fill: ({ health }) => ({
        background: healthColor(Math.max(0, Math.min(1, health / models_1.MAX_HEALTH))),
    }),
    content: {
        position: "absolute",
        top: "-2px",
        right: "8px",
        fontSize: "12px",
        fontWeight: 700,
        color: "#000",
    },
});
const renderHealthbar = (current) => `${current} / ${models_1.MAX_HEALTH} hp`;
function PlayerHealthbar({ health }) {
    const classes = useStyles({ health });
    return (React.createElement(progressBar_1.ProgressBar, { className: classes.playerHealth, fillClassName: classes.fill, contentClassName: classes.content, current: health, max: models_1.MAX_HEALTH, renderContents: renderHealthbar }));
}
